<div>
  @for (changeBlock of changeEvents; track changeBlock) {
    <div>
      @if (!!changeBlock.nodeId) {
        <h4>{{'history.event-block.node-title.0'|translate:nodeChangeBlockTranslation(changeBlock)}}
          <span [class.linkPart]="isActive(changeBlock)" (click)="browseToNode(changeBlock)">{{'history.event-block.node-title.1'|translate:nodeChangeBlockTranslation(changeBlock)}}</span>
          {{'history.event-block.node-title.2'|translate:nodeChangeBlockTranslation(changeBlock)}}
        </h4>
      }
      @if (!!changeBlock.resourceId) {
        <h4>{{'history.event-block.resource-title.0'|translate:resourceChangeBlockTranslation(changeBlock)}}
          <span>{{'history.event-block.resource-title.1'|translate:resourceChangeBlockTranslation(changeBlock)}}</span>
          {{'history.event-block.resource-title.2'|translate:resourceChangeBlockTranslation(changeBlock)}}
        </h4>
      }
      <div>
        @for (event of changeBlock.events; track event) {
          <div>
            @switch (event.eventType) {
              @case (EventTypes.NODE_LABELS_CHANGED) {
                <pm-node-labels-changed-renderer [event]="event | convertTo:NodeLabelsChanged"></pm-node-labels-changed-renderer>
              }
              @case (EventTypes.NODE_LINK_ADDED||EventTypes.NODE_LINK_DELETED) {
                <pm-node-links-changed-renderer [event]="event | convertTo:NodeLinksChanged"></pm-node-links-changed-renderer>
              }
              @case (EventTypes.RESOURCE_COLOR_CHANGED) {
                <pm-resource-color-changed-renderer [event]="event | convertTo:ResourceColorChanged"></pm-resource-color-changed-renderer>
              }
              @default {
                <pm-default-history-renderer [event]="event"></pm-default-history-renderer>
              }
            }
          </div>
        }
      </div>
    </div>
  }
</div>
